import React, { useEffect, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { TableUrlPagination } from '../../../../ui'
import { useRowSelector } from '../../../loader/hooks'
import { guildsIP3DataPreparation } from '../../logics'
import { GUILDS_IP3_TABLE_COLUMNS } from '../../constants'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const GuildsIP3Table = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const navigate = useNavigate()
  const role = useSelector((state) => state.global.role)
  const guildsLoader = useSelector((state) => state.loader.guildIP3)
  const combos = useSelector((state) => state.combos)

  const data = guildsLoader?.data?.gremios || []
  const totalEntries = guildsLoader?.data?.total_empresas
  const search = guildsLoader?.config?.params
  const loading = guildsLoader?.loading

  const { selection, addSelection } = useRowSelector({
    identifier: 'guildsIP3',
    selectFilter: (state) => state?.data?.gremios,
    idField: 'gremio_id',
  })

  useEffect(() => {
    if (selection.length) {
      addSelection([])
    }
  }, [])

  const handleGoToDetail = (e, row) => {
    navigate(`/guilds/${row.gremio_id}`)
  }

  const handleSelectRows = useCallback(
    (rows) => {
      addSelection(rows)
    },
    [addSelection]
  )

  const formattedColumns = useMemo(() => {
    return GUILDS_IP3_TABLE_COLUMNS.map((column) => {
      const baseColumn = {
        accessorKey: column.field,
        header: formatMessage({ id: `pages.guildsIP3.table.columns.${column.field}.title` }),
        size: column.width,
        minSize: column.width,
        maxSize: column.width,
      }

      if (column.field === 'actions') {
        return {
          ...baseColumn,
          header: formatMessage({ id: 'global.actions' }),
          Cell: (props) => <span>Acciones</span>, // Replace with actual actions component
          muiTableBodyCellProps: { align: 'center' },
        }
      }

      if (column.comboId && combos[column.comboId]?.data) {
        const lookup = getLookup(combos[column.comboId].data)
        return {
          ...baseColumn,
          Cell: ({ cell }) => {
            const value = cell.getValue()
            return <span>{lookup[value] ?? value ?? '--'}</span>
          },
        }
      }

      return {
        ...baseColumn,
        Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
      }
    })
  }, [combos, formatMessage])

  const processedData = useMemo(() => guildsIP3DataPreparation(data, intl), [data, intl])

  const finalTableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: role === 'e_commerce',
      draggable: false,
    }),
    [role]
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={finalTableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
      onSelectionChange={handleSelectRows}
      onRowClick={handleGoToDetail}
    />
  )
}
